import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config/apiConfig";

const MarketplacePaymentSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [status, setStatus] = useState("checking"); // checking | success | failed

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const reference = params.get("reference") || params.get("trxref");
        if (!reference) {
            setStatus("failed");
            return;
        }

        const verify = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/api/marketplace/verify/${reference}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                });
                const data = await res.json();
                setStatus(data.status === "success" ? "success" : "failed");
            } catch (err) {
                setStatus("failed");
            }
        };
        verify();
    }, [location]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
            <div className="bg-white rounded-2xl shadow-sm p-10 text-center max-w-sm">
                {status === "checking" && (
                    <>
                        <h1 className="text-xl font-bold text-gray-800">Confirming your payment...</h1>
                        <p className="text-gray-500 mt-2">This only takes a moment.</p>
                    </>
                )}
                {status === "success" && (
                    <>
                        <h1 className="text-xl font-bold text-green-600">Purchase complete!</h1>
                        <p className="text-gray-500 mt-2 mb-6">You now have access to this bundle.</p>
                        <button onClick={() => navigate("/marketplace")} className="bg-blue600 text-white px-5 py-2 rounded-lg font-semibold">
                            Go to Marketplace
                        </button>
                    </>
                )}
                {status === "failed" && (
                    <>
                        <h1 className="text-xl font-bold text-red-500">Payment not confirmed</h1>
                        <p className="text-gray-500 mt-2 mb-6">If you completed checkout, try again in a moment — Paystack can take a few seconds.</p>
                        <button onClick={() => navigate("/marketplace")} className="bg-blue600 text-white px-5 py-2 rounded-lg font-semibold">
                            Back to Marketplace
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default MarketplacePaymentSuccess;
